import { render, staticRenderFns } from "./CustomPlanEdit.vue?vue&type=template&id=2fde8852&"
import script from "./CustomPlanEdit.vue?vue&type=script&lang=js&"
export * from "./CustomPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports